// extracted by mini-css-extract-plugin
module.exports = {"section":"form-module--section--2AT3f","sectionTitle":"form-module--sectionTitle--25WCb"};